<!-- dynamicForm.vue -->
<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div :style="{ fontFamily: fontFamily }" class="w-100 m-1 p-3">
    <div v-if="formData.title" class="d-flex justify-content-center">
        <div v-html="formData.title"></div>
    </div>
    <form @submit.prevent="submitForm" ref="formDynamic" :style="getStyleGroup('form',row)" :class="getClassGroup('form',0)">
        <div v-if="fieldsReady" class="container">   
          <div v-for="row in transformedFields._ar_" :key="'row-' + row" :class="'row nivel-row ' + getClassGroup('rows',row)" :style="getStyleGroup('rows',row)">
            <template v-if="showIf('rows',row)">
                <div v-for="col in transformedFields[row]._ar_" :key="'col-' + col" :class="'nivel-col ' + getClassCols(transformedFields[row]._ar_)+ getClassGroup('cols',col)"  :style="getStyleGroup('cols',col)">
                  <template v-if="showIf('cols',col)">
                      <div v-for="sub in transformedFields[row][col]._ar_" :key="'sub-' + sub" :class="'sub nivel-sub '+ getClassGroup('subs',sub)"  :style="getStyleGroup('subs',sub)">
                        <template v-if="showIf('subs',sub)">
                          <div v-for="group in transformedFields[row][col][sub]._ar_" :key="'group-' + group" :class="'row group nivel-group '+ getClassGroup('groups',group)" :style="getStyleGroup('groups',group)">
                            <template v-if="showIf('groups',group)">
                              <div v-for="fieldKey in fieldListGroup(transformedFields[row][col][sub][group]._ar_)" :key="'field-' + fieldKey" :class="'field nivel-field '+getClassCols(transformedFields[row][col][sub][group]._ar_)" :style="getStyleGroup('fields',fieldKey.field)">
                                  <template v-if="showIf('fields',fieldKey.field)" >
                                    <formField
                                      :field="formData.fields[fieldKey.field]"
                                      :form-values="formValues"
                                      :error-messages="errorMessages"
                                      :dynamic-components="dynamicComponents"
                                      :form-data="formData"
                                      :name="sanitizeName(fieldKey.field)"
                                      group="no"
                                      @setValueChangeToReg="setValueChangeToReg"
                                      :update-form-values="updateFormValues"
                                    />
                                  </template>
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                  </template>
                </div>
            </template>
          </div>
        </div>
    </form>
    <div ref="menufooter" class="barraFooter form-floating col-span-2" :style="BarFooterStyle">
        <div class="buttons-left">
            <button v-if="!isVerified&&isVerified" class="btn-form btn-valid" @click.prevent="preSubmitForm"><i class="fas fa-check"></i> Validar</button>
            <button v-if="!isSaved" :class="buttons.save.class" :style="`${buttons.save.styles}; display: inline-flex; align-items: center;`"  @click.prevent="submitForm">
              <icon :data="buttons.save.icon"  style="margin-right: 8px;"/> {{buttons.save.label}}
            </button>
            <i v-if="isSaved && isVerified" class="p-1 m-1 fa-2x fas fa-check-circle success-icon"></i>
            <button v-if="dataReceived" class="btn-form btn-new" @click.prevent="clearForm"><i class="fas fa-broom"></i> Nueva</button>
        </div>
        <button v-if="ifIsDeleteable" class="btn-form btn-delete" @click.prevent="deleteRow"><i class="fas fa-trash"></i> Eliminar</button>
    </div>
  </div>
</template>

<script>
import { replaceKeys, isNotSet, isSet } from '@/js/utils.js';
import {checkField,checkFieldSync,checkNestedValues} from '@/js/checkField.js';
import formField from '@/components/formField.vue';

export default {
  components: {
    formField
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formValues: {},
      dynamicComponents: {},
      isVerified: false,
      errorCheck: false,
      isSaved: false,
      groups: {},
      errorMessages: {},
      dataReceived: false,
      showComponent: {},
      fieldsReady: false,
      nCols : [],
      cacheField: {},
      transformedFields: {},
      buttons: {"save":{"label":"Grabar","class":"btn_save_","icon":"save", "style":"font-size: 1.25rem;background: none; border: none; padding: 0; color: #007bff; text-decoration: underline; cursor: pointer;"}}
    }
  },
  computed: {
    fontFamily() {
      return (this.formData.fontFamily) ? this.formData.fontFamily : "'Courier New', monospace;"
    },
    groupedFields() {
      return Object.values(this.formData.fields).sort(this.sortFields).reduce((acc, field) => {
        const col = field.col ?? 0;
        acc[col] = acc[col] || [];
        this.nCols[Number(col)] = true;
        acc[col].push(field);
        return acc;
      }, {});
    },
  
    listFields() {
         return Object.values(this.formData.fields)
            .map(field => {
              if (field.type === 'group' && field.subs) {
                field.subs = this.list_sFields(field.subs);
              }
              return field;
            })
            .sort((a, b) => {
              return (a.col ?? 0) - (b.col ?? 0) || a.num - b.num;
            });
    },  
    ifIsDeleteable() {
      console.log("deleteteable :", this.formData.deleteAction, " saved:", this.isSaved, "dataReceived:", this.dataReceived);
      const st = isSet(this.formData.deleteAction) && (this.isSaved || this.dataReceived);
      console.log("paso....", st);
      return st;
    },
  },
  methods: {
    buttonsDefaults() {
      this.buttons = (this.formData.buttons) ? this.formData.buttons : this.buttons;
    },
    fieldListGroup(ar) {
      return ar.sort((a, b) => {
        return a.num - b.num;
      });
    },
    prepareFields(fields) {
      const transformed = {
        _ar_: []
      };

      Object.keys(fields).forEach(key => {
        const field = fields[key];
        const row = field.row || 0;
        const col = field.col || 0;
        const sub = field.sub || 0;
        const group = field.group || 0;
        const num = field.num || 0;

        if (!transformed[row]) {
          transformed[row] = { _ar_: [] };
          transformed._ar_.push(row);
        }
        if (!transformed[row][col]) {
          transformed[row][col] = { _ar_: [] };
          transformed[row]._ar_.push(col);
        }
        if (!transformed[row][col][sub]) {
          transformed[row][col][sub] = { _ar_: [] };
          transformed[row][col]._ar_.push(sub);
        }
        if (!transformed[row][col][sub][group]) {
          transformed[row][col][sub][group] = { _ar_: [] };
          transformed[row][col][sub]._ar_.push(group);
        }
        transformed[row][col][sub][group]._ar_.push({ "field": key, "num": num });
      });

      // Sort each _ar_ list for better structure
      const sortArList = (obj) => {
        if (obj._ar_) {
          obj._ar_.sort((a, b) => a - b);
          obj._ar_.forEach(key => { if (obj[key]) sortArList(obj[key]) });
        }
      };

      sortArList(transformed);
// eslint-disable-next-line 
       //debugger;
      this.transformedFields = transformed;
    },
    getFieldsSubs(subId) {
      return Object.values(this.formData.fields).filter(field => field.sub === subId);
    },
    showIf(type,key) {
        if (isNotSet(this.formData.vIf[type])) return true;
        if (isNotSet(this.formData.vIf[type][key])) return true;
        const vIf = this.formData.vIf[type][key]
        const {field} = vIf
        // eslint-disable-next-line 
        // debugger; 
        if (isNotSet(this.formValues[field])) return false;
        const typeKey = `${type}__${key}`
        if (isNotSet(this.cacheField[field])) this.cacheField[field]={}
        if (isNotSet(this.cacheField[field][typeKey])) this.cacheField[field][typeKey]=null
        if (this.cacheField[field][typeKey] === true) return true;
        if (this.cacheField[field][typeKey] === false) return false;        
        const stCheck = checkFieldSync(field, vIf, this.formData.fields[field], this.formValues);
        this.cacheField[field][typeKey]=stCheck.status;
        if (stCheck.status === false) return false;
        return stCheck.status; 
    },
    getClassCols(group_) {
      const num = group_.length
      if ( num === 1 ) return "group col-12";
      if ( num === 2 ) return "group col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6";
      if ( num === 3 ) return "group col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4";
      if ( num === 4 ) return "group col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3";
      return "group col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3";
    },
    getClassGroup(gr,id) {
      if (!this.formData.class) return "";
      let def = "";
      if (!this.formData.class[gr]) return "";
      if (this.formData.class[gr].all) def=this.formData.class[gr].all;
      if (!this.formData.class[gr][id]) return def;
      return (def+" "+this.formData.class[gr][id]);
    },
    getStyleGroup(gr,id) {
      if (!this.formData.styles) return "";
      if (!this.formData.styles[gr]) return "";
      if (!this.formData.styles[gr][id]) return "";
      return this.formData.styles[gr][id];
    },
    sortFields(a, b) {
      return (a.col ?? 0) - (b.col ?? 0) || a.num - b.num;
    },
    idComponent(field) {
      return (field.component.idComponent) ?  field.component.idComponent : field.component.id
    },
    isReadonly(ro) {
      return ro || false;
    },
    setInputValue(json) {
      if (typeof json === "object") this.setValueChangeToReg(json);
    },
    ifType(type) {
      const types = ['component', 'checkbox', 'select', 'image', 'textarea', 'radio', "label"];
      return types.includes(type);
    },
    async checkDBonChange() {
      this.isVerified = false;
      this.isSaved = false;
      const keyValue = replaceKeys(this.formData.keyDB, this.formValues);
      if (this.formData.onSubmit.toLowerCase() === "api") {
        const action = this.formData.getAction ? this.formData.getAction : "getData";
        const st = await this.$api.call(action, { key: keyValue });
        if (st.data) {
          this.setValueChangeToReg(st.data);
          this.isSaved = true;
        } else {
          this.isSaved = false;
        }
      }
      if (this.formData.onSubmit === "FS") {
        const data = await this.$Genv.fsCia.collection(this.formData.collection).doc(keyValue).get();
        if (data) {
          this.setValueChangeToReg(data );
          this.isSaved = true
        } else {
          this.isSaved = false;
        }
      }
    },
    async preSubmitForm() {
      if (!this.isVerified) {
        if (this.$refs.formDynamic.reportValidity()) {
          const st = await this.checkDataForm();
          if (st.status === true) {
            this.errorCheck = false;
            this.isVerified = true;
          } else {
            this.isVerified = false;
            this.errorCheck = true;
          }
        } else {
          console.log("La validación de HTML5 ha fallado en uno o más campos.");
          this.isVerified = false;
        }
      }
    },
    async submitForm() {
      if (!this.isVerified) {
        await this.preSubmitForm()
        if (!this.isVerified) return;
      }
      if (this.formData.sets) this.setValueChangeToReg(this.formData.sets );
      const keyValue = replaceKeys(this.formData.keyDB, this.formValues);
      if (this.formData.onSubmit.toLowerCase() === "api" || isSet(this.formData.setAction)) {
         this.saveDataInServer(keyValue);
      }
      if (this.formData.onSubmit === "FS") {
        await this.$Genv.fsCia.collection(this.formData.collection).doc(keyValue).set(checkNestedValues(this.formValues), { merge: true });
        this.isSaved = true;
        this.$eventBus.emit("newMessage",{msg:"Datos grabados...",time:10})
      }
    },
    async saveDataInServer(keyValue) {

      const data = {
        'data': checkNestedValues(this.formValues),
        'key':  JSON.stringify(keyValue),
        'params': this.formData
      }
      const action = this.formData.setAction ? this.formData.setAction : "forms.saveForm";
      const st = await this.$api.call(action, data  );
      if (st.status === true) { 
        this.isSaved = true; 
        this.$eventBus.emit("newMessage",{msg:"Datos grabados...",time:10}) 
        return 
      }
      else return false;

    },
    async clearForm() {
      for (const f in this.formValues) this.formValues[f] = null;
      this.isSaved = false;
      this.dataReceived = false;
      this.isVerified = false;
      this.errorCheck = false;
    },
    async deleteRow() {
      if (this.formData.onSubmit.toLowerCase() === "api") {
        const action = this.formData.deleteAction ? this.formData.deleteAction : "deleteForm";
        await this.$api.call(action, checkNestedValues(this.formValues));
        for (const f in this.formValues) this.formValues[f] = null;
        this.isSaved = false;
        this.dataReceived = false;
      }
    },
    async preloadData() {
        const action = this.formData.preloadData ? this.formData.preloadData : "preloadData";
        let st = {}
       // debugger;  //eslint-disable-line 
        if (!window.preload ) st = await this.$api.call(action,{"fields":this.formData.fields} );
        else st = {status:true, data: window.preload }
        console.log("Preloaded data:",st.data)
        if (st.status && st.data) {
            console.log("data preloaded Ori:",st.data)
            Object.keys(st.data).forEach(field => {
              if (this.formData.fields[field]) {
                let value =  st.data[field];
                if (isNotSet(value)) return;
                if (this.formData.fields[field].type === "checkbox") {
                   value = (value === 1 || value === "1" || value === "true" || value === true) ? true : false;
                }
                this.formValues[field] = value;
                this.$eventBus.emit("setValue_"+field.replace(/@/,"_"),st.data[field]);
                console.log("preloaded field:"+field+" = "+ st.data[field])
              }
            });
            console.log("data preloaded:",this.formValues)
        }
        else console.log("Error preload:",st)

    },
    setValueChangeToReg(newValues) {
                      
        //debugger; // eslint-disable-line 

        if (Object.keys(newValues).length < 1) return;
        this.formValues = { ...this.formValues, ...newValues };
        Object.keys(newValues).forEach(field => {
          const cache = this.cacheField[field]
          if (isSet(cache)) {
            for (const typeKey in cache)   {
              const [type, key] = typeKey.split("__")
              this.cacheField[field][typeKey] = null;
              this.showIf(type,key)
            }
          }
        });
        this.isVerified = false;
        this.isSaved = false;
    },
    sanitizeName(name) {
      return name.replace(/[@]/g, '__at__');
    },
    async checkDataForm() {
      let checkError = false;
      for (const f in this.formData.valid) {

        const sanitizedName = this.sanitizeName(f);
        const fieldElement = this.$el.querySelector(`[name='${sanitizedName}']`);
        debugger; //eslint-disable-line
        if (!fieldElement) continue;
        delete this.errorMessages[f];
        const stCheck = await checkField(f, this.formData.valid[f], this.formData.fields[f], this.formValues);
        if (stCheck.status === false) {
          this.errorMessages[f] = stCheck.msg;
          this.$eventBus.emit("newMessage",{msg:`${this.formData.fields[f].label} ${stCheck.msg}`,time:5})
          checkError = true;
          break;
        }
        if (stCheck.setData) this.formValues = {...this.formValues, ...stCheck.setData}
      }
      return { status: !checkError };
    },
    getClassRowIf(col) {
      col = Number(col)
      //const c0 = (this.esPar(col)) ? col+1 : col-1;
      if (this.esPar(col)) return "row-if row"
      return "row-if ";
    },
    getColClass(col) {
      col = Number(col)
      const c0 = (this.esPar(col)) ? col+1 : col-1;
      if (this.nCols[c0] && this.nCols[col]) return "col-if col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6";
      return "col-if col-12 col-sm-12 col-lg-12 p-0";
    },
    esPar(col) {
      return Number(col) % 2 === 0;
    },
    updateFormValues(newValues) {
      // eslint-disable-next-line 
        //debugger;
        this.setValueChangeToReg(newValues);
    },
    list_sFields(subs) {
      return Object.values(subs).sort((a, b) => {
        return (a.col ?? 0) - (b.col ?? 0) || a.num - b.num;
      });
    },
    async loadComponents(field) {
      if (!field) {
      console.error("El campo es undefined.");
      return;
    }
        if (field.type == 'radio' || field.type == 'checkbox' || field.type == 'image') {
            const name = (field.type == 'radio') ? "radiobuttonInput" : ((field.type == 'image') ? "uploadImageField" : "checkboxInput");
            if (!this.dynamicComponents[name]) {
                if (!field.component) field.component={id:name}
                else field.component.id = name
                const loadedComponent = await import(`@/components/${name}.vue`);
                this.dynamicComponents[name] = loadedComponent.default;  
                this.showComponent[field.id] = true
            }
        else this.showComponent[field.id] = true
      }
      if (['component',"radio","checkbox","image"].includes(field.type) && field.component) {
          field.component.id = this.idComponent(field);
          if (!this.dynamicComponents[field.component.id]) {
            const loadedComponent = await import(`@/components/${field.component.id}.vue`);
            this.dynamicComponents[field.component.id] = loadedComponent.default;
            this.showComponent[field.id] = true
          }
          else this.showComponent[field.id] = true
      }
      if (isSet(field.default) && isNotSet(this.formValues[field.id])) this.formValues[field.id] = field.default;
      if (field.group) {
        const group = `${field.col || "0"}_${field.group ? field.group : "0"}` ;
        this.groups[group] = this.groups[group] ? this.groups[group] + 1 : 1;
        // eslint-disable-next-line 
        //debugger;
      }
    }
  },
  async created() {
    if (window.isWordpress === true) {
      const module = await import("@/js/WP_api.js");
      this.$api = module.$api;
    }
  },
  async mounted() {
    this.buttonsDefaults();
    const fieldPromises = this.listFields.map(async field => {
      await this.loadComponents(field);
    });
    this.prepareFields(this.formData.fields)
    await Promise.all(fieldPromises);
    console.log("formData:",this.formData)
    if (isSet(this.formData.preloadData)) {
      await this.preloadData();
      console.log("data preloaded..................")
    }
    if (this.formData.data && Object.keys(this.formData.data).length > 0) {
      this.setValueChangeToReg(this.formData.data);
      this.dataReceived = true;
    }
    this.fieldsReady=true;
  },
};
</script>

<style scoped>
.centrar-verticalmente {
  display: flex;
  align-items: center; /* Centrar verticalmente */
  height: 100%; /* Asegúrate de que el contenedor tenga una altura definida */
}

/* Estilos para el botón Validar */
.btn-valid {
  background-color: #4caf50; /* Color verde */
  color: white;
}

.btn-valid i:before {
  content: "\f00c"; /* Código del icono Font Awesome para check */
  margin-right: 10px;
}


.btn-valid:hover {
  background-color: #45a049; /* Color verde oscuro al pasar el cursor */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

/* Estilos para el botón Grabar */
.btn-save {
  background-color: #ebece8; /* Color azul */
  color: #1d1d1b;
}

.btn-save i:before {
  content: "\f0c7"; /* Código del icono Font Awesome para save */
  margin-right: 10px;
}

.btn-form {
  padding: 10px 20px;
  border-radius: 5px;
  margin-right: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  margin-bottom: 2px;
}

.btn-delete {
  background-color: #fa6e47; /* Color azul */
  color: white;
}

.btn-delete i:before {
  content: "\f1f8"; /* Código del icono Font Awesome para delete/trash */
  margin-right: 10px;
}

.error-icon {
  color: red;
  margin-left: 10px;
}

.success-icon {
  color: green;
  margin-left: 10px;
}
.left-border {
 box-shadow: -1px 0 1px -1px rgba(0, 0, 0, 0.8), 1px 0 1px -1px rgba(0, 0, 0, 0.8);
}

.btn-save:hover {
  background-color: #e0e0de; /* Color azul oscuro al pasar el cursor */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.btn-new {
  background-color: #f7fdfe; /* Color azul */
  color: rgb(42, 41, 41);
}

.image-container {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 140px;
  height: 140px;
  padding: 0;
  margin: 0;
  object-fit: cover;
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  overflow: hidden;
  z-index: 20;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invalid-feedback {
  color: red;
  font-size: 10px; /* Ajusta el tamaño del texto según necesites */
}

.form-floating {
  display: flex;
  justify-content: space-between; /* Alinea los elementos a ambos extremos */
  align-items: center; /* Centra los elementos verticalmente */
}

.buttons-left {
  display: flex;
  flex-wrap: wrap; /* Permite que los elementos se envuelvan si no caben en una sola línea */
  gap: 10px; /* Espacio entre botones, ajusta según necesites */
}
.group-doble {
  padding-right: 0px;
}

.row-if {
  max-width: 100%;
}
</style>
